import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import LandingHeader from '../../components/LandingPageComponents/LandingHeader/LandingHeader';
import LandingFooter from '../../components/LandingPageComponents/LandingFooter/LandingFooter';
import BlogHeroSection from '../../components/BlogComponents/BlogHeroSection';
import BlogFeaturedSection from '../../components/BlogComponents/BlogFeaturedSection/BlogFeaturedSection';
import { CircularProgress } from '@mui/material';
import { useDispatch } from 'react-redux';
import { getAllBlog } from '../../store/redux/slices/blogSlice';
import BookDemoPopup from '../LandingPage/partials/BookDemoPopup';
import { Helmet } from 'react-helmet-async';

const Wrapper = styled.div`
  width: 100%;
  overflow: hidden;
  overflow-y: scroll;
  background: radial-gradient(
    95.86% 126.4% at 0% 5.38%,
    rgba(226, 243, 187, 0.7) 0%,
    rgba(157, 200, 187, 0.7) 100%
  );
  height: 100vh; /* warning: gradient uses a rotation that is not supported by CSS and may not behave as expected */
  display: flex;
  flex-direction: column;
  align-items: center;
  @media only screen and (max-width: 768px) {
    max-height: ${(props) => (props.menuOpen ? '100vh' : 'unset')};
  }
`;
const HeaderWrapper = styled.div`
  // position: fixed;
  width: 100%;
  top: 0;
  z-index: 9;
  @media only screen and (max-width: 768px) {
    position: unset;
    display: flex;
    justify-content: center;
  }
`;
const CircularLoader = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 10;
  top: 0px;
  right: 10px;
  background-color: rgba(0, 0, 0, 0.5);

  & > div {
    position: fixed;
    top: 50%;
    left: 50%;
  }

  & svg {
    transform: scale(2);
  }
`;
const ResourcesPage = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const dispatch = useDispatch();
  const [blogData, setBlogData] = useState([]);
  const getData = async () => {
    setBlogData(null);
    const data = await dispatch(getAllBlog());
    var tempData = data?.payload?.data;
    const temp = tempData?.map((data) => {
      return {
        id: data?.blog_id,
        image: data?.preview_image_url,
        textLeft: 'Template',
        textright: 'Levelling Up',
        heading: data?.title,
        date: data?.published_at,
        time: data?.time_to_read,
      };
    });
    setBlogData(temp);
  };

  useEffect(() => {
    getData();
    window.scrollTo(0, 0);
  }, []);
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
    <Helmet>
        <title>BrandAstra Blogs | Emotional Intelligence in Marketing</title>
        <meta name="description" content="Discover how emotional intelligence in marketing enhances customer engagement, brand loyalty, and decision-making. Learn how BrandAstra’s sentiment analysis, social listening, and competitor insights can optimize marketing strategies. Improve brand perception and predict consumer behavior with real-time artificial intelligence (AI) insights." />
        <meta name="keywords" content="BrandAstra, social listening, AI insights" />
        <link rel="canonical" href="https://qa.brandastra.ai/resources" />
      </Helmet>
     <Wrapper menuOpen={menuOpen}>
      <HeaderWrapper>
        <LandingHeader
          newTheme={true}
          bgColor={'linear-gradient(95.02deg, #A0D925 -65.35%, #006A68 100%)'}
          setMenuOpen={(data) => {
            setMenuOpen(data);
          }}
          setPopupOpen={(data) => setIsOpen(data)}
        />
      </HeaderWrapper>
      {blogData === null || blogData === undefined || blogData?.length < 1 ? (
        <CircularLoader>
          <div>
            <CircularProgress />
          </div>
        </CircularLoader>
      ) : (
        <>
          <BlogHeroSection />
          <BlogFeaturedSection blogData={blogData} />
        </>
      )}
      <BookDemoPopup isOpen={isOpen} setIsOpen={(data) => setIsOpen(data)} />
      <LandingFooter bgColor={'#021826'} />
    </Wrapper>
    </>
   
  );
};

export default ResourcesPage;
